<template>
  <DxPopup
    :visible="getVisible"
    @hidden="onPopupHide"
    :drag-enabled="false"
    :hide-on-outside-click="false"
    :show-close-button="false"
    :show-title="true"
    :width="'75%'"
    :height="600"
    :title="popupConfig.title"
    :wrapper-attr="{
      class: 'css-v2 gc-popup gc-popup-form gc-popup-shifts',
    }"
    ref="gc-popup"
    @shown="onShown"
    @initialized="onInitialized"
  >
    <DxToolbarItem
      v-if="popupConfig.formMode !== 'create' && popupConfig.secondaryTitle"
      location="before"
      :html="`<span class='toolbar-title-secondary text-secondary'> ${popupConfig.secondaryTitle}</span>`"
    ></DxToolbarItem>

    <DxToolbarItem
      v-for="(item, index) in getToolbarItems"
      :key="index"
      :widget="item.widget"
      :location="item.location"
      :visible="item.visible"
      :toolbar="item.position"
      :options="item.options"
      :template="item.template ? item.template : null"
    />

    <template #switchTemplate>
      <div style="display: flex; align-items: center; gap: 8px">
        <span>Active</span>
        <DxSwitch
          :value="model.Inactive === 'Y' ? false : true"
          @value-changed="
            (e) => {
              model.Inactive = e.value ? 'N' : 'Y';
            }
          "
          :read-only="popupConfig.formMode === 'review'"
        />
      </div>
    </template>

    <div class="css-v2 gc-popup-form">
      <GcForm
        :key="popupConfig.formKey"
        :formOptions="{
          gcLabelLocation: 'left',
        }"
        :formItems="getHeaderFormItems"
        :isNormal="true"
        :data-model="model"
        :formMode="popupConfig.formMode"
        :validationGroup="'gc-form-comp-shifts'"
        :formLocation="'normal'"
        :formHeight="95"
        ref="gc-form-comp-shifts"
        :valueChangeCallBack="valueChangeCallBack"
        :checkValid="isValid"
      />
    </div>

    <div class="css-v2 gc-popup-data-grid">
      <div class="shift-tabs">
        <DxTabs
          :selected-index="SelectedIndex"
          :items="[
            {
              id: 0,
              text: 'Downtime',
            },
            {
              id: 1,
              text: 'Process',
            },
          ]"
          :orientation="'horizontal'"
          :styling-mode="'secondary'"
          :width="'auto'"
          :keyExpr="'id'"
          @itemClick="onTabItemClick"
        />
      </div>
      <div class="data-grid-content">
        <div>
          <!-- Downtime Content Here -->
          <dx-data-grid
            :data-source="getDataSource"
            :columns="getColumns"
            :show-borders="true"
            :height="354"
            :row-alternation-enabled="true"
            :columnChooser="{
              enabled: false,
            }"
            :pager="{ visible: false }"
            :column-auto-width="false"
            @toolbar-preparing="onToolbarPreparing($event)"
            @editor-preparing="onEditorPreparing"
            @content-ready="onContentReady"
            @row-removed="onRowRemoved"
            @editing-start="onEditingStart"
            @focusedCellChanged="onFocusedCellChanged"
            @focusedCellChanging="onFocusedCellChanging"
            :ref="'shifts-tab-grid-downtime'"
            :key-expr="'id'"
          >
            <DxEditing
              :allow-deleting="popupConfig.formMode !== 'review'"
              :allow-updating="popupConfig.formMode !== 'review'"
              :mode="'cell'"
              :confirm-delete="false"
            />

            <template #overrideDowntimeSwitchTemplate="{ data }">
              <div class="overrid-downtime-switch">
                <dx-switch
                  :value="data.data.HasUniqueDownTime"
                  @value-changed="onOverrideDowntimeSwitchChanged($event, data)"
                  :readOnly="popupConfig.formMode === 'review'"
                />
                <dx-button
                  :icon="popupConfig.formMode !== 'review' ? 'edit' : ''"
                  :text="'Downtime'"
                  :width="80"
                  :disabled="!data.data.HasUniqueDownTime"
                  @click="showProcessShiftRecurringDowntime($event, data)"
                />
              </div>
            </template>

            <template #planningDeductionMinutesSwitchTemplate="{ data }">
              <div class="overrid-downtime-switch">
                <dx-switch
                  :value="data.data.PlanningDeductionMinutes"
                  @value-changed="
                    onPlanningDeductionMinutesSwitchChanged($event, data)
                  "
                  :readOnly="popupConfig.formMode === 'review'"
                />
                <dx-button
                  :icon="popupConfig.formMode !== 'review' ? 'edit' : ''"
                  :text="'Deduction'"
                  :width="80"
                  :disabled="!data.data.PlanningDeductionMinutes"
                  @click="showOverrideDeduction($event, data)"
                />
              </div>
            </template>
          </dx-data-grid>
        </div>
      </div>
    </div>

    <DxLoadPanel
      :position="{ of: '#container-wrapper' }"
      :visible.sync="loadingVisible"
      :show-indicator="true"
      :show-pane="true"
      :shading="true"
      :hide-on-outside-click="false"
      shading-color="rgba(0,0,0,0)"
    />

    <GcPopupAudit
      v-if="popupAuditVisible"
      :showPopup.sync="popupAuditVisible"
      :model.sync="auditModel"
    />

    <GcPopupProcessShiftRecurringDowntime
      :popupConfig="DowntimeDeductionPopupConfig"
      :data-model="dataModel"
      :on-hide="onDowntimeDeductionPopupHide"
      v-if="
        DowntimeDeductionPopupConfig.isPopupShow &&
        DowntimeDeductionPopupConfig.Deduction === false
      "
      :displayServerError="displayServerError"
      @onSaveRecurringDowntime="onSaveRecurringDowntime"
    />

    <GcPopupProcessShiftRecurringDeduction
      v-if="
        DowntimeDeductionPopupConfig.isPopupShow &&
        DowntimeDeductionPopupConfig.Deduction === true
      "
      :data-model="dataModel"
      :displayServerError="displayServerError"
      :popupConfig="DowntimeDeductionPopupConfig"
      :on-hide="onDowntimeDeductionPopupHide"
      @onSaveRecurringDeduction="onSaveRecurringDeduction"
    />
  </DxPopup>
</template>
<script>
import DataGridMixin from "@/_mixins/data-grid.mixin";
import { mapGetters } from "vuex";
import DxSwitch from "devextreme-vue/switch";
import { ProcessCapacityService } from "../../_services/api/production/process-capacity.service";
import { FeatureStorage } from "../../_services/storage";
import ArrayStore from "devextreme/data/array_store";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import { backwardTabbing, forwardTabbing } from "../../_helpers/ui/keyboard";
import {
  durationToTime,
  IsResponseDataValid,
  minutesTo24Hour,
  to24Hour,
} from "../../_helpers/ui/helpers";

import GcPopupProcessShiftRecurringDowntime from "./gc-popup-process-shift-recurring-downtime.vue";
import GcPopupProcessShiftRecurringDeduction from "./gc-popup-process-shift-recurring-deduction.vue";
import { DateFromIsoWithoutZ } from "../../_helpers/prototypes/prototype-date";

const downTimeBaseLine = {
  id: null,
  Description: null,
  StartTime: null,
  EndTime: null,
  DurationMins: null,
  RecordId: null,
  StartTimeEnter: false,
  EndTimeEnter: false,
};

const shiftProcessBaseLine = {
  id: null,
  ProcessCode: null,
  ProcessDescription: null,
  Days: null,
  DateStart: null,
  DateEnd: null,
  HasUniqueShiftWindow: false,
  StartTime: null,
  EndTime: null,
  HasUniqueDownTime: false,
  PlanningDeductionMinutes: false,
  ProcessShiftRecurringDownTimes: [],
  StartTimeEnter: false,
  EndTimeEnter: false,
};

export default {
  mixins: [DataGridMixin],
  components: {
    DxSwitch,
    GcPopupProcessShiftRecurringDowntime,
    GcPopupProcessShiftRecurringDeduction,
  },
  data() {
    return {
      IsFormLoaded: false,
      model: {
        Code: null,
        Description: null,
        StartTime: null,
        EndTime: null,
        ShiftDurationMins: null,
        Inactive: "N",
        RecordId: null,
      },
      isValid: false,
      loadingVisible: false,
      SelectedIndex: 0,
      DownTimeDataSource: new ArrayStore({
        key: "id",
        data: [],
      }),
      ShiftProcessDataSource: new ArrayStore({
        key: "id",
        data: [],
      }),
      popupAuditVisible: false,
      auditModel: {
        createdBy: "",
        dateCreated: "",
        changedBy: "",
        dateChanged: "",
      },

      DowntimeDeductionPopupConfig: {
        Deduction: false,
        title: "",
        secondaryTitle: undefined,
        isFormLoading: false,
        popupKey: 0,
        formKey: 0,
        height: 500,
        isPopupShow: false,
        hideOnOutsideClick: false,
        formMode: "edit",
        isEditable: false,
        dataModel: undefined,
      },
    };
  },
  props: {
    popupConfig: {
      type: Object,
      default: () => {
        return {
          isPopupShow: false,
          formMode: "create",
          formKey: 1,
          secondaryTitle: "",
        };
      },
    },
    wrapperAttr: {
      type: Object,
      default: () => {},
    },
    dataModel: {
      type: Object,
      default: () => {},
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
    displayServerError: {
      type: Function,
      default: function () {},
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    onHide: {
      type: Function,
      default: () => {},
    },
  },
  async created() {},
  methods: {
    /* Popup Events */
    async onShown() {
      this.loadingVisible = true;
      this.model = {
        Code: null,
        Description: null,
        StartTime: null,
        EndTime: null,
        ShiftDurationMins: null,
        Inactive: "N",
        RecordId: null,
        ShiftDurationHrs: null,
      };

      if (this.dataModel) {
        this.model = { ...this.dataModel };

        // Calculate Shift Duration
        if (this.model.StartTime && this.model.EndTime) {
          const start = this.model.StartTime;
          const end = this.model.EndTime;

          const calculateShiftMinutes = (startTime, endTime) => {
            // Parse time strings (HH:mm format)
            const [startHours, startMinutes] = startTime.split(":").map(Number);
            const [endHours, endMinutes] = endTime.split(":").map(Number);

            // Convert to total minutes
            let startTotalMinutes = startHours * 60 + startMinutes;
            let endTotalMinutes = endHours * 60 + endMinutes;

            // Handle overnight shifts
            if (endTotalMinutes < startTotalMinutes) {
              endTotalMinutes += 24 * 60; // Add 24 hours
            }

            return endTotalMinutes - startTotalMinutes;
          };

          this.model.ShiftDurationMins = Math.ceil(
            calculateShiftMinutes(start, end),
          );
        }

        if (this.model.StartTime) {
          this.model.StartTime = this.timeStringToDate(this.model.StartTime);
        } else {
          this.model.StartTime = new Date();
        }

        if (this.model.EndTime) {
          this.model.EndTime = this.timeStringToDate(this.model.EndTime);
        } else {
          this.model.EndTime = new Date();
        }

        // Audit Model
        this.auditModel.createdBy = this.dataModel.CreatedBy;
        this.auditModel.dateCreated = this.dataModel.DateCreated;
        this.auditModel.changedBy = this.dataModel.ChangedBy;
        this.auditModel.dateChanged = this.dataModel.DateChanged;
      }
      await this.initializeModel();
      this.$store.dispatch("hotKey/setHotKeyPopupMode", true);
      this.$nextTick(() => {
        this.loadingVisible = false;
        this.setFocusOnField("Code");
      });
    },

    async initializeModel() {
      if (this.popupConfig.formMode === "create") {
        this.DownTimeDataSource.insert({
          ...downTimeBaseLine,
        });
        this.ShiftProcessDataSource.insert({
          ...shiftProcessBaseLine,
        });
      } else {
        await this.getShiftDownTime();
        await this.getProcessShiftRecurring();
      }
    },

    async getShiftDownTime() {
      await ProcessCapacityService.getShiftDownTime(this.model.RecordId)
        .then((res) => {
          if (IsResponseDataValid(res)) {
            const data = res.data.value;
            data.forEach((item) => {
              item.Description = item.Name;
              item.StartTime = durationToTime(item.StartTime);
              item.EndTime = durationToTime(item.EndTime);
              item.DurationMins = item.Minutes;

              this.DownTimeDataSource.insert({
                ...item,
              });
            });
          }
        })
        .catch((err) => {
          this.displayServerError(err);
        });
    },
    async getProcessShiftRecurring() {
      await ProcessCapacityService.getProcessShiftRecurring(
        this.model.RecordId,
      ).then((res) => {
        if (IsResponseDataValid(res)) {
          const data = res.data.value;
          data.forEach((item) => {
            item.ProcessDescription = item.ProcessName;
            item.Days = this.mapFlagsToDays(item);
            item.PlanningDeductionMinutes = this.hasAnyPlanningDeduction(item);
            if (item.StartTime) {
              item.StartTime = DateFromIsoWithoutZ(item.StartTime);
            }
            if (item.EndTime) {
              item.EndTime = DateFromIsoWithoutZ(item.EndTime);
            }

            if (item.DateStart) {
              item.DateStart = DateFromIsoWithoutZ(item.DateStart);
            }

            if (item.DateEnd) {
              item.DateEnd = DateFromIsoWithoutZ(item.DateEnd);
            }

            item.ProcessShiftRecurringDownTimes.forEach((dt) => {
              dt.Description = dt.Name;
              dt.StartTime = durationToTime(dt.StartTime);
              dt.EndTime = durationToTime(dt.EndTime);
            });

            const insertData = {
              ...shiftProcessBaseLine,
              ...item,
            };

            this.ShiftProcessDataSource.insert(insertData);
          });
        }
      });
    },

    mapFlagsToDays(flags) {
      if (!flags) return [];

      const dayMap = {
        IsOnMonday: "Mon",
        IsOnTuesday: "Tue",
        IsOnWednesday: "Wed",
        IsOnThursday: "Thu",
        IsOnFriday: "Fri",
        IsOnSaturday: "Sat",
        IsOnSunday: "Sun",
      };

      return Object.entries(dayMap)
        .filter(([key]) => flags[key])
        .map(([, val]) => val);
    },

    hasAnyPlanningDeduction(apiResponse) {
      return Object.keys(apiResponse).some(
        (key) =>
          key.startsWith("PlanningDeductionMinutes") && apiResponse[key] > 0,
      );
    },

    addNewEditableRow() {
      if (this.SelectedIndex === 0) {
        this.DownTimeDataSource.insert({
          ...downTimeBaseLine,
        });
      } else {
        this.ShiftProcessDataSource.insert({
          ...shiftProcessBaseLine,
        });
      }
    },

    timeStringToDate(timeStr) {
      if (!timeStr) return null;

      const [hours, minutes] = timeStr.split(":").map(Number);

      const date = new Date(1970, 0, 1, hours, minutes, 0, 0);
      return date;
    },

    /*
    Popup Hide Event
    */
    onPopupHide(repaint = true) {
      this.$emit("setIsVisible", false);

      this.onHide(repaint);
      this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
    },

    /**
     * Popup Initialized Event
     * @param e
     */
    onInitialized(e) {
      this.IsFormLoaded = true;
      e.component.registerKeyHandler("escape", (arg) => {
        arg.stopPropagation();

        this.$nextTick(() => {
          this.onCancelPopupHandler();
        });
      });
    },

    /**
     * Cancel Popup Handler
     */
    async onCancelPopupHandler() {
      if (this.popupConfig.formMode === "review") {
        this.onPopupHide(false);
        return;
      }
      if (this.popupConfig.isPopupShow) {
        const confirm = await this.$confirm(
          `You have unsaved changes. Are you sure you want to leave?`,
          "Unsaved changes",
          {
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            type: "warning",
          },
        );
        if (confirm) {
          this.onPopupHide(false);
        }
      }
    },

    /**
     * Set Focus On Field
     * @param dataField
     */
    setFocusOnField(dataField) {
      if (this.popupConfig.formMode !== "review") {
        if (this.getFormInstance) {
          const form = this.getFormInstance.instance;
          form.getEditor(dataField).focus();
        }
      }
    },

    updateFormValues(dataField, value) {
      if (this.getFormInstance) {
        const form = this.getFormInstance.instance;
        form.beginUpdate();
        form.updateData(dataField, value);
        form.endUpdate();
      }
    },

    updateFieldOptions(dataField, options) {
      if (this.getFormInstance) {
        const form = this.getFormInstance.instance;
        const editor = form.getEditor(dataField);
        if (editor) {
          editor.option(options.name, options.value);
        }
      }
    },

    onSavePopupHandler() {
      this.isValid = true;
    },
    /**
     * Value Change Call Back
     * @param isValid Validation Status
     * @param brokenRules
     */
    async valueChangeCallBack(isValid, brokenRules) {
      var validations = "";
      this.isValid = false;

      if (!isValid) {
        brokenRules.forEach((element) => {
          validations += `<div style="width: 400px; padding-bottom: 5px;">${element.message}</div>`;
        });

        try {
          await this.$alert(validations, "Validation Error", {
            width: 400,
          });
        } catch (error) {
          // User might have pressed ESC, but we still need to reset
        }
      } else {
        // Shift Save Here

        const finalResult = {
          Code: this.model.Code.trimEnd(),
          Description: this.model.Description.trimEnd(),
          StartTime: to24Hour(this.model.StartTime),
          EndTime: to24Hour(this.model.EndTime),
          Inactive: this.model.Inactive,
          ShiftDownTimes: [],
          ProcessShiftRecurrings: [],
        };

        const downTimes = await this.DownTimeDataSource.load({
          filter: [["Description", "<>", null]],
        });

        if (downTimes.length > 0) {
          const result = this.validateDowntimes(
            downTimes,
            this.model.StartTime,
            this.model.EndTime,
          );

          if (!result.valid) {
            this.$alert(result.message, "Validation Error");
            return;
          } else {
            downTimes.forEach((dt) => {
              const startTimeStr = dt.StartTime ? to24Hour(dt.StartTime) : null;
              const endTimeStr = dt.EndTime ? to24Hour(dt.EndTime) : null;

              const downtime = {
                Name: dt.Description.trimEnd(),
                StartTime: startTimeStr,
                EndTime: endTimeStr,
              };

              if (dt.RecordID) {
                downtime.RecordId = dt.RecordID;
              }
              finalResult.ShiftDownTimes.push(downtime);
            });
          }
        }

        const processEntries = await this.ShiftProcessDataSource.load({
          filter: [["ProcessCode", "<>", null]],
        });

        if (processEntries.length > 0) {
          const validation = await this.validateAllProcessShifts(
            processEntries,
          );

          if (!validation.isValid) {
            this.$alert(validation.message, "Validation Error");
            return false; // block save
          }

          const overRideShiftErrors = processEntries.filter(
            (pe) =>
              pe.HasUniqueShiftWindow &&
              (pe.StartTime === null || pe.EndTime === null),
          );

          const dateValidation = processEntries.filter((pe) => {
            if (pe.ProcessCode && !pe.DateStart) {
              return pe;
            }
          });

          const daysValidationErrors = processEntries.filter(
            (item) =>
              item.ProcessCode && (!item.Days || item.Days.length === 0),
          );

          if (daysValidationErrors.length > 0) {
            await this.$alert(
              `At least one day must be selected for this Process ${daysValidationErrors[0].ProcessDescription} Shift.`,
              "Validation Error",
            );
            this.SelectedIndex = 1;

            this.$nextTick(() => {
              this.focusOnEditableGridCell("Days", daysValidationErrors[0]);
            });
            return;
          } else if (overRideShiftErrors.length > 0) {
            await this.$alert(
              "When override shift is enabled, 'Start Time' and 'End Time' must be set for all process entries.",
              "Validation Error",
            );
            this.SelectedIndex = 1;

            this.$nextTick(() => {
              this.focusOnEditableGridCell("StartTime", overRideShiftErrors[0]);
            });
            return;
          } else if (dateValidation.length > 0) {
            await this.$alert(
              "Process entries must have a valid 'Start Date'.",
              "Validation Error",
            );
            this.SelectedIndex = 1;

            this.$nextTick(() => {
              this.focusOnEditableGridCell("DateStart", dateValidation[0]);
            });
            return;
          } else {
            processEntries.forEach((pe) => {
              const startTimeStr = pe.StartTime ? to24Hour(pe.StartTime) : null;
              const endTimeStr = pe.EndTime ? to24Hour(pe.EndTime) : null;

              const flags = this.mapDaysToFlags(pe.Days);

              const processEntry = {
                DateStart: new Date(pe.DateStart).toYYYYMMDD(),
                DateEnd: pe.DateEnd ? new Date(pe.DateEnd).toYYYYMMDD() : null,
                StartTime: startTimeStr
                  ? this.constructShiftDateTimes(
                      pe.DateStart,
                      pe.DateEnd,
                      startTimeStr,
                      endTimeStr,
                    ).StartTime
                  : null,
                EndTime: endTimeStr
                  ? this.constructShiftDateTimes(
                      pe.DateStart,
                      pe.DateEnd,
                      startTimeStr,
                      endTimeStr,
                    ).EndTime
                  : null,
                HasUniqueShiftWindow: pe.HasUniqueShiftWindow,
                HasUniqueDownTime: pe.HasUniqueDownTime,
                PlanningDeductionMinutes: pe.PlanningDeductionMinutes,
                ProcessRecordId: pe.ProcessRecordId,
                ProcessShiftRecurringDownTimes:
                  pe.ProcessShiftRecurringDownTimes
                    ? pe.ProcessShiftRecurringDownTimes.map((dt) => ({
                        Name: dt.Description.trimEnd(),
                        StartTime: to24Hour(dt.StartTime),
                        EndTime: to24Hour(dt.EndTime),
                        RecordId: dt.RecordID,
                      }))
                    : [],
                PlanningDeductionMinutesMonday:
                  pe.PlanningDeductionMinutesMonday || 0,
                PlanningDeductionMinutesTuesday:
                  pe.PlanningDeductionMinutesTuesday || 0,
                PlanningDeductionMinutesWednesday:
                  pe.PlanningDeductionMinutesWednesday || 0,
                PlanningDeductionMinutesThursday:
                  pe.PlanningDeductionMinutesThursday || 0,
                PlanningDeductionMinutesFriday:
                  pe.PlanningDeductionMinutesFriday || 0,
                PlanningDeductionMinutesSaturday:
                  pe.PlanningDeductionMinutesSaturday || 0,
                PlanningDeductionMinutesSunday:
                  pe.PlanningDeductionMinutesSunday || 0,
              };

              Object.assign(processEntry, flags);

              if (pe.RecordID) {
                processEntry.RecordId = pe.RecordID;
              }

              finalResult.ProcessShiftRecurrings.push(processEntry);
            });
          }
        }

        this.loadingVisible = true;

        const isEdit = this.popupConfig.formMode === "edit";

        if (isEdit) {
          finalResult.RecordId = this.model.RecordId;
        }

        const successMessage = isEdit
          ? "Shift updated successfully."
          : "Shift saved successfully.";

        this.loadingVisible = true;

        try {
          await ProcessCapacityService.saveShift(finalResult);
          await this.$notify(successMessage, "success");
          this.onPopupHide();
        } catch (error) {
          this.displayServerError(error);
        } finally {
          this.loadingVisible = false;
        }
      }

      // Always reset isValid after processing
      this.$nextTick(() => {
        this.isValid = false;
      });
    },

    constructShiftDateTimes(
      startDateStr,
      endDateStr,
      startTimeStr,
      endTimeStr,
    ) {
      // Parse dates
      const startDate = new Date(startDateStr); // required
      const endDate = endDateStr ? new Date(endDateStr) : null; // optional

      // Parse hours/minutes
      const [startHour, startMinute] = startTimeStr.split(":").map(Number);
      const [endHour, endMinute] = endTimeStr.split(":").map(Number);

      // Construct StartTime
      const startTime = new Date(startDate);
      startTime.setHours(startHour, startMinute, 0, 0);

      let endTime;

      if (endDate) {
        // If EndDate is provided, use it
        endTime = new Date(endDate);
        endTime.setHours(endHour, endMinute, 0, 0);
      } else {
        // No EndDate, use StartDate with midnight crossing logic
        if (
          endHour > startHour ||
          (endHour === startHour && endMinute >= startMinute)
        ) {
          // Normal case: same day
          endTime = new Date(startDate);
          endTime.setHours(endHour, endMinute, 0, 0);
        } else {
          // Midnight crossing: add 1 day
          endTime = new Date(startDate);
          endTime.setDate(endTime.getDate() + 1);
          endTime.setHours(endHour, endMinute, 0, 0);
        }
      }

      return {
        StartTime: startTime.toSaveDateTime(),
        EndTime: endTime.toSaveDateTime(),
      };
    },
    mapDaysToFlags(daysInput) {
      if (!daysInput) {
        return this.getEmptyFlags();
      }

      // Support both string "Mon,Tue" and array ["Mon","Tue"]
      const daysArray = Array.isArray(daysInput)
        ? daysInput
        : daysInput.split(",");

      const normalized = daysArray.map((d) => d.trim().toLowerCase());

      return {
        IsOnMonday: normalized.includes("mon"),
        IsOnTuesday: normalized.includes("tue"),
        IsOnWednesday: normalized.includes("wed"),
        IsOnThursday: normalized.includes("thu"),
        IsOnFriday: normalized.includes("fri"),
        IsOnSaturday: normalized.includes("sat"),
        IsOnSunday: normalized.includes("sun"),
      };
    },
    getEmptyFlags() {
      return {
        IsOnMonday: false,
        IsOnTuesday: false,
        IsOnWednesday: false,
        IsOnThursday: false,
        IsOnFriday: false,
        IsOnSaturday: false,
        IsOnSunday: false,
      };
    },

    validateDowntimes(rows, mainShiftStart, mainShiftEnd) {
      const timeRanges = [];

      const shiftStart = new Date(mainShiftStart);
      const shiftEnd = new Date(mainShiftEnd);

      //
      const MINUTES_IN_DAY = 1440;
      const toShiftRelativeMinutes = (timeValue, shiftStartValue) => {
        const t = new Date(timeValue);
        const s = new Date(shiftStartValue);

        const timeMinutes = t.getHours() * 60 + t.getMinutes();
        const shiftStartMinutes = s.getHours() * 60 + s.getMinutes();

        let diff = timeMinutes - shiftStartMinutes;

        // If time is "before" shift start, it belongs to next day
        if (diff < 0) diff += MINUTES_IN_DAY;

        return diff;
      };

      const shiftDurationMinutes =
        toShiftRelativeMinutes(mainShiftEnd, mainShiftStart) || MINUTES_IN_DAY;

      let shiftStartMs = shiftStart.getTime();
      let shiftEndMs = shiftEnd.getTime();

      // If shift crosses midnight, push end to next day
      if (shiftEndMs <= shiftStartMs) {
        shiftEndMs += 24 * 60 * 60 * 1000;
      }

      for (const row of rows) {
        const { Description, StartTime, EndTime } = row;

        const hasDescription = !!Description;
        const hasStart = !!StartTime;
        const hasEnd = !!EndTime;

        // RULE 1 — Description requires times
        if (hasDescription && (!hasStart || !hasEnd)) {
          return {
            valid: false,
            message: `Downtime "${Description}" must have start and end times.`,
            row,
          };
        }

        if (!hasDescription && !hasStart && !hasEnd) continue;

        if (hasDescription && hasStart && hasEnd) {
          let startMin = toShiftRelativeMinutes(StartTime, mainShiftStart);
          let endMin = toShiftRelativeMinutes(EndTime, mainShiftStart);

          // Downtime crosses midnight inside shift
          if (endMin <= startMin) endMin += MINUTES_IN_DAY;

          // ❗ Must be fully inside shift window
          if (startMin < 0 || endMin > shiftDurationMinutes) {
            return {
              valid: false,
              message: `Downtime "${Description}" must be within the shift time range.`,
              row,
            };
          }

          timeRanges.push({
            Description,
            startMs: startMin,
            endMs: endMin,
          });
        }
      }

      // RULE 3 — Overlap detection
      timeRanges.sort((a, b) => a.startMs - b.startMs);

      for (let i = 0; i < timeRanges.length - 1; i++) {
        if (timeRanges[i].endMs > timeRanges[i + 1].startMs) {
          return {
            valid: false,
            message: `Downtime "${timeRanges[i].Description}" overlaps with "${
              timeRanges[i + 1].Description
            }".`,
            row: timeRanges[i],
          };
        }
      }

      return { valid: true };
    },
    /**
     * Handle Audit Popup
     */
    onAuditPopupHandler() {
      this.popupAuditVisible = !this.popupAuditVisible;
    },

    onEditPopupHandler() {
      this.popupConfig.title = "Edit Shift - " + this.model.Code;
      this.popupConfig.formMode = "edit";
      this.popupConfig.formKey++;
      // Add a new editable row if none exist
      this.DownTimeDataSource.insert({
        ...downTimeBaseLine,
      });

      this.ShiftProcessDataSource.insert({
        ...shiftProcessBaseLine,
      });

      this.$nextTick(() => {
        setTimeout(() => this.setFocusOnField("Code"), 700);
      });
    },

    onStartDateChange(e) {
      if (!e.event && this.popupConfig.formMode === "review") return;
      else if (!e.event && !e.value) {
        this.model.StartTime = null;
        this.model.EndTime = null;
        this.model.ShiftDurationMins = null;
        this.updateFormValues("EndTime", this.model.EndTime);
        this.updateFormValues(
          "ShiftDurationMins",
          this.model.ShiftDurationMins,
        );
        return;
      }

      this.model.StartTime = e.value;
      this.model.EndTime = undefined;
      this.model.ShiftDurationMins = 0;

      // this.$nextTick(() => {
      //   this.setFocusOnField("EndTime");
      // });
    },

    onEndDateChange(e) {
      if (!e.event && this.popupConfig.formMode === "review") return;
      else if (!e.event && !e.value) {
        this.model.EndTime = null;
        this.model.ShiftDurationMins = null;
        this.updateFormValues(
          "ShiftDurationMins",
          this.model.ShiftDurationMins,
        );
        return;
      }

      this.model.EndTime = e.value;

      if (this.model.StartTime && this.model.EndTime) {
        const start = this.model.StartTime;
        const end = this.model.EndTime;

        // Normalize both to the SAME day (1970-01-01)
        const normalizedStart = new Date(
          1970,
          0,
          1,
          start.getHours(),
          start.getMinutes(),
        );
        let normalizedEnd = new Date(
          1970,
          0,
          1,
          end.getHours(),
          end.getMinutes(),
        );

        let duration = (normalizedEnd - normalizedStart) / (1000 * 60);

        // SAME TIME = FULL 24 HOURS
        if (duration === 0) {
          duration = 24 * 60;
        }
        // Handle overnight shift (end past midnight)
        else if (duration < 0) {
          duration += 24 * 60;
        }
        this.model.ShiftDurationMins = Math.ceil(duration);
      } else {
        this.model.ShiftDurationMins = null;
      }

      this.updateFormValues("ShiftDurationMins", this.model.ShiftDurationMins);
    },

    onTabItemClick(e) {
      if (!e.event) return;
      if (this.dataGrid) {
        this.dataGrid.clearSelection();
        this.dataGrid.option("focusedRowIndex", -1);
      }
      this.$nextTick(() => {
        this.SelectedIndex = e.itemIndex;
      });
    },
    /**
     * on so list grid toolbar preparing
     * @param e - event
     */
    onToolbarPreparing(e) {
      e.toolbarOptions.visible = false;
    },

    onContentReady(e) {
      setTimeout(() => {
        this.$nextTick(() => {
          e.component.beginUpdate();
          e.component.updateDimensions();
          e.component.endUpdate();

          if (this.SelectedIndex === 0) {
            this.addGridNoResults(e, {
              addNew: {
                class: "no-data",
                title: "No Downtime",
                message: "No Downtime entries found.",
              },
            });
          } else {
            this.addGridNoResults(e, {
              addNew: {
                class: "no-data",
                title: "No Process",
                message: "No Process entries found.",
              },
            });
          }
        });
      }, 2000);
    },

    onEditorPreparing(e) {
      if (e.parentType !== "searchPanel") {
        const { dataField, editorOptions, row } = e;
        // Only wrap handlers if not in the search panel
        if (!editorOptions) return;

        const wrapHandler = (handlerName) => {
          const original = editorOptions[handlerName];
          if (typeof original === "function") {
            editorOptions[handlerName] = (event) => {
              original(event, {
                column: { dataField },
                data: row.data,
                rowIndex: row.rowIndex,
              });
            };
          }
        };

        // Wrap each handler if it exists
        [
          "onFocusIn",
          "onFocusOut",
          "onKeyDown",
          "onValueChanged",
          "onInput",
        ].forEach(wrapHandler);
      }

      if (e.dataField && e.dataField == "ProcessCode") {
        e.editorName = "dxSelectBox";
      }

      if (e.dataField && e.dataField == "Days") {
        e.editorName = "dxTagBox";
      }
    },
    async onRowRemoved(e) {
      if (!e) return;
      let items = [];
      if (this.SelectedIndex === 0) {
        items = await this.DownTimeDataSource.load();
      } else {
        items = await this.ShiftProcessDataSource.load();
      }
      if (items.length === 0) {
        this.addNewEditableRow();
      } else if (items[items.length - 1].Description !== null) {
        this.addNewEditableRow();
      }
    },

    async onEditingStart(e) {
      if (!e) return;

      if (this.SelectedIndex === 0) {
        if (!this.model.StartTime) {
          e.cancel = true;
          await this.$alert(
            "Please set Shift Start Time before editing Downtime entries.",
            "Validation Error",
          );
          this.setFocusOnField("StartTime");
        } else if (!this.model.EndTime) {
          e.cancel = true;
          await this.$alert(
            "Please set Shift End Time before editing Downtime entries.",
            "Validation Error",
          );
          this.setFocusOnField("EndTime");
        }
      }

      if (e.column && this.SelectedIndex === 1) {
        const column = e.column;
        const data = e.data;

        if (!data) return;
        if (
          (column.dataField === "StartTime" ||
            column.dataField === "EndTime") &&
          !data.HasUniqueShiftWindow
        ) {
          e.cancel = true;
        }
      }
    },

    onFocusedCellChanging(e) {
      if (this.SelectedIndex === 1 && e.event) {
        const data = e.rows[e.newRowIndex].data;
        if (!data) return;
        if (forwardTabbing(e)) {
          if (
            e.columns[e.prevColumnIndex].dataField === "HasUniqueShiftWindow"
          ) {
            e.event.preventDefault();
            if (data.HasUniqueShiftWindow)
              this.$nextTick(() => {
                this.focusOnEditableGridCell("StartTime", data);
              });
            else {
              this.$nextTick(() => {
                this.focusOnEditableGridCell("HasUniqueDownTime", data);
              });
            }
          }
        }

        if (backwardTabbing(e)) {
          if (e.columns[e.prevColumnIndex].dataField === "HasUniqueDownTime") {
            e.event.preventDefault();
            if (data.HasUniqueShiftWindow) {
              this.$nextTick(() => {
                this.focusOnEditableGridCell("EndTime", data);
              });
            } else {
              this.$nextTick(() => {
                this.focusOnEditableGridCell("HasUniqueShiftWindow", data);
              });
            }
          }
        }
      }
    },

    async onFocusedCellChanged(e) {
      if (!e || !e.row) return;
      const key = e.row.key;
      if (this.SelectedIndex === 1) {
        const items = await this.ShiftProcessDataSource.load({
          filter: [["id", "<>", key], "and", ["ProcessCode", "<>", null]],
          keyType: {
            id: "Guid",
          },
          fieldType: {
            id: "Guid",
          },
        });

        const timeValidationErrors = items.filter(
          (item) =>
            item.HasUniqueShiftWindow &&
            (item.StartTime === null || item.EndTime === null),
        );

        const daysValidationErrors = items.filter(
          (item) => item.ProcessCode && (!item.Days || item.Days.length === 0),
        );

        if (timeValidationErrors.length > 0) {
          await this.$alert(
            "When override shift is enabled, 'Start Time' and 'End Time' must be set.",
            "Validation Error",
          );

          const rowIndex = this.dataGrid.getRowIndexByKey(
            timeValidationErrors[0].id,
          );
          if (rowIndex === -1) return;
          this.focusOnEditableGridCell("StartTime", timeValidationErrors[0]);
        } else if (daysValidationErrors.length > 0) {
          await this.$alert(
            `At least one day must be selected for this Process ${daysValidationErrors[0].ProcessDescription} Shift.`,
            "Validation Error",
          );

          const rowIndex = this.dataGrid.getRowIndexByKey(
            daysValidationErrors[0].id,
          );
          if (rowIndex === -1) return;
          this.focusOnEditableGridCell("Days", daysValidationErrors[0]);
        } else {
          // DateStart is required if the process is selected
          const dateValidationErrors = items.filter(
            (item) => item.ProcessCode && !item.DateStart,
          );

          if (dateValidationErrors.length > 0) {
            await this.$alert(
              "'Date Start' is required when a process is selected.",
              "Validation Error",
            );

            const rowIndex = this.dataGrid.getRowIndexByKey(
              dateValidationErrors[0].id,
            );
            if (rowIndex === -1) return;
            this.focusOnEditableGridCell("DateStart", dateValidationErrors[0]);
          }
        }
      }
    },

    focusOnEditableGridCell(dataField, rowData = null) {
      if (this.dataGrid) {
        const dataGrid = this.dataGrid;
        let rowIndex = 0;
        if (rowData) {
          rowIndex = dataGrid.getRowIndexByKey(rowData.id);
        }
        if (rowIndex === -1) return;
        const cellElement = dataGrid.getCellElement(rowIndex, dataField);
        dataGrid.focus(cellElement);
        setTimeout(() => {
          dataGrid.editCell(rowIndex, dataField);
        }, 10);
      }
    },

    onOverrideDowntimeSwitchChanged(e, data) {
      if (!e || !e.event) return;
      data.data.HasUniqueDownTime = e.value;
      this.$nextTick(() => {
        this.focusOnEditableGridCell("PlanningDeductionMinutes", data.data);
      });
    },
    async onPlanningDeductionMinutesSwitchChanged(e, data) {
      if (!e || !e.event) return;
      data.data.PlanningDeductionMinutes = e.value;

      if (!e.value) {
        data.data.PlanningDeductionMinutesMonday = 0;
        data.data.PlanningDeductionMinutesTuesday = 0;
        data.data.PlanningDeductionMinutesWednesday = 0;
        data.data.PlanningDeductionMinutesThursday = 0;
        data.data.PlanningDeductionMinutesFriday = 0;
        data.data.PlanningDeductionMinutesSaturday = 0;
        data.data.PlanningDeductionMinutesSunday = 0;
      }

      if (!data.data.ProcessCode) {
        await this.$alert(
          "Please select a process before configuring deduction.",
          "Validation Error",
        );

        this.focusOnEditableGridCell("ProcessCode", data.data);
        return;
      }
      this.$nextTick(() => {
        const rowIndex = this.dataGrid.getRowIndexByKey(data.data.id);
        if (rowIndex === -1) return;
        // check if this is the last row, if so add a new row and focus on it, otherwise focus on the next row
        if (rowIndex === this.dataGrid.getVisibleRows().length - 1) {
          this.ShiftProcessDataSource.insert({
            ...shiftProcessBaseLine,
          });
          this.$nextTick(() => {
            this.focusOnEditableGridCell(
              "ProcessCode",
              this.ShiftProcessDataSource._array[rowIndex + 1],
            );
          });
        } else {
          this.focusOnEditableGridCell(
            "ProcessCode",
            this.ShiftProcessDataSource._array[rowIndex + 1],
          );
        }
      });
    },

    async showProcessShiftRecurringDowntime(e, data) {
      if (!e || !data) return;
      const row = data.data;

      if (row.HasUniqueShiftWindow && (!row.StartTime || !row.EndTime)) {
        await this.$alert(
          "When override shift is enabled, 'Start Time' and 'End Time' must be set before configuring downtime.",
          "Validation Error",
        );

        this.focusOnEditableGridCell(
          !row.StartTime ? "StartTime" : "EndTime",
          row,
        );
        return;
      }
      await this.openDowntimeDeductionPopup({ e, data, isDeduction: false });
    },

    async showOverrideDeduction(e, data) {
      await this.openDowntimeDeductionPopup({ e, data, isDeduction: true });
    },

    async openDowntimeDeductionPopup({ e, data, isDeduction = false }) {
      if (!e || !data) return;

      const row = data.data;

      if (!row.ProcessCode) {
        await this.$alert(
          `Please select a process before configuring ${
            isDeduction ? "deduction" : "downtime"
          }.`,
          "Validation Error",
        );

        this.focusOnEditableGridCell("ProcessCode", row);
        return;
      }

      const mode = this.popupConfig.formMode;

      const titleMap = {
        create: `Add ${isDeduction ? "Deduction (Hrs)" : "Downtime"}`,
        edit: `Edit ${isDeduction ? "Deduction (Hrs)" : "Downtime"}`,
        review: isDeduction ? "Deduction (Hrs)" : "Downtime",
      };

      this.DowntimeDeductionPopupConfig = {
        ...this.DowntimeDeductionPopupConfig,
        Deduction: isDeduction,
        title: titleMap[mode],
        formMode: mode,
        dataModel: { ...row },
        isPopupShow: true,
        secondaryTitle:
          mode === "review"
            ? `for Process: ${row.ProcessCode} - ${row.ProcessDescription}`
            : undefined,
        shiftData: this.model,
      };
    },
    onDowntimeDeductionPopupHide() {
      this.DowntimeDeductionPopupConfig.isPopupShow = false;
      this.DowntimeDeductionPopupConfig.dataModel = undefined;
      this.DowntimeDeductionPopupConfig.Deduction = false;
      this.DowntimeDeductionPopupConfig.secondaryTitle = undefined;
    },

    onSaveRecurringDowntime(downTimes) {
      const data = this.DowntimeDeductionPopupConfig.dataModel;

      // Update the ShiftProcessDataSource with the new downtime entries
      this.ShiftProcessDataSource.update(data.id, {
        ProcessShiftRecurringDownTimes: downTimes,
        HasUniqueDownTime: true,
      });

      this.onDowntimeDeductionPopupHide();
    },

    onSaveRecurringDeduction(deductionMinutes) {
      let validData = deductionMinutes[0];
      delete validData.id;
      this.ShiftProcessDataSource.update(
        this.DowntimeDeductionPopupConfig.dataModel.id,
        {
          ...validData,
        },
      );

      this.$nextTick(() => {
        this.onDowntimeDeductionPopupHide();
      });
    },

    async validateAllProcessShifts(dataSet) {
      const FAR_FUTURE = new Date("9999-12-31");

      // Loop over each record
      for (let i = 0; i < dataSet.length; i++) {
        const current = dataSet[i];
        const currentStart = new Date(current.DateStart);
        const currentEnd = current.DateEnd
          ? new Date(current.DateEnd)
          : FAR_FUTURE;

        // Compare with every other record in the dataset
        for (let j = 0; j < dataSet.length; j++) {
          if (i === j) continue; // skip self

          const other = dataSet[j];
          if (other.ProcessCode !== current.ProcessCode) continue;

          const otherStart = new Date(other.DateStart);
          const otherEnd = other.DateEnd ? new Date(other.DateEnd) : FAR_FUTURE;

          // Duplicate exact dates
          const isDuplicate =
            currentStart.getTime() === otherStart.getTime() &&
            (other.DateEnd
              ? currentEnd.getTime() === otherEnd.getTime()
              : !current.DateEnd);

          if (isDuplicate) {
            return {
              isValid: false,
              message:
                "A process shift entry conflicts with an existing date range (including open-ended ranges). Please update the start/end dates.",
            };
          }

          // Overlap check
          const isOverlapping =
            currentStart <= otherEnd && currentEnd >= otherStart;

          if (isOverlapping) {
            return {
              isValid: false,
              message:
                "A process shift entry conflicts with an existing date range (including open-ended ranges). Please update the start/end dates.",
            };
          }
        }
      }

      // Passed all checks
      return { isValid: true };
    },

    getActiveTimeDataSource() {
      return this.SelectedIndex === 0
        ? this.DownTimeDataSource
        : this.ShiftProcessDataSource;
    },
  },
  computed: {
    ...mapGetters({ getHotKeySave: "hotKey/getHotKeySave" }),
    getVisible() {
      if (this.popupConfig.isPopupShow) return this.popupConfig.isPopupShow;
      else return false;
    },
    /**
     * Get Header Form Items
     */
    getHeaderFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 3,
          items: [
            // First Row: Code (1 column) and Description (2 columns)
            {
              dataField: "Code",
              label: { text: "Code", location: "left" },
              editorType: "dxTextBox",
              colSpan: 1,
              editorOptions: {
                tabIndex: 1,
                maxLength: 10,
              },
              validationRules: [
                {
                  type: "required",
                  message: "Code is required",
                },
              ],
            },
            {
              dataField: "Description",
              label: { text: "Description", location: "left" },
              editorType: "dxTextBox",
              colSpan: 2,
              editorOptions: {
                tabIndex: 2,
                maxLength: 50,
              },
              validationRules: [
                {
                  type: "required",
                  message: "Description is required",
                },
              ],
            },
            // Second Row: Start Time, End Time, Shift Duration (each 1 column)
            {
              dataField: "StartTime",
              label: { text: "Start Time", location: "left" },
              editorType: "dxDateBox",
              colSpan: 1,
              editorOptions: {
                width: "100%",
                displayFormat: "HH:mm",
                tabIndex: 3,
                type: "time",
                onValueChanged: this.onStartDateChange,
                placeholder: "Select Time",
                onInput: (e) => {
                  const inputElement = e.event.target;
                  const val = inputElement.value;

                  if (this.model.StartTime === null && val) {
                    const hour = val.split(":")[0];
                    if (hour && !isNaN(hour)) {
                      const newTime = new Date();
                      newTime.setHours(parseInt(hour), 0, 0, 0);
                      e.component.option("value", newTime);
                    }
                  }
                },
              },
              validationRules: [
                {
                  type: "required",
                  message: "Start Time is required",
                },
              ],
            },
            {
              dataField: "EndTime",
              label: { text: "End Time", location: "left" },
              editorType: "dxDateBox",
              colSpan: 1,
              editorOptions: {
                width: "100%",
                displayFormat: "HH:mm",
                tabIndex: 4,
                type: "time",
                onValueChanged: this.onEndDateChange,
                // min: this.model.StartTime,
                placeholder: "Select Time",
                onKeyDown: (e) => {
                  if (!e.event) return;
                  if (forwardTabbing(e)) {
                    e.event.preventDefault();
                    let dataField = "Description";
                    if (this.SelectedIndex === 1) {
                      dataField = "ProcessCode";
                    }
                    this.$nextTick(() => {
                      this.focusOnEditableGridCell(dataField);
                    });
                  }
                },
                onInput: (e) => {
                  const inputElement = e.event.target;
                  const val = inputElement.value;

                  if (this.model.EndTime === null && val) {
                    const hour = val.split(":")[0];
                    if (hour && !isNaN(hour)) {
                      const newTime = new Date();
                      newTime.setHours(parseInt(hour), 0, 0, 0);
                      e.component.option("value", newTime);
                    }
                  }
                },
              },
              validationRules: [
                {
                  type: "required",
                  message: "End Time is required",
                },
              ],
            },
            {
              dataField: "ShiftDurationHrs",
              label: { text: "Shift Duration (Hrs)", location: "left" },
              editorType: "dxTextBox",
              colSpan: 1,
              editorOptions: {
                width: "100%",
                tabIndex: -1,
                min: 0,
                readOnly: true,
              },
            },
          ],
        },
      ];
    },

    /**
     * Get Toolbar Items
     */
    getToolbarItems() {
      return [
        {
          widget: "dxSwitch",
          location: "after",
          toolbar: "top",
          template: "switchTemplate",
          options: {
            value: this.model.Inactive === "Y" ? false : true,
            readOnly: this.popupConfig.formMode === "review",
          },
        },

        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: this.popupConfig.formMode === "review",
          options: {
            icon: "clock",
            onClick: this.onAuditPopupHandler,
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible:
            this.popupConfig.formMode === "review" &&
            FeatureStorage.checkPermission("ProcessCapacity", "edit"),
          options: {
            icon: "edit",
            onClick: this.onEditPopupHandler,
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: this.popupConfig.formMode !== "review",
          options: {
            text: "Save",
            stylingMode: "contained",
            type: "default",
            onClick: this.onSavePopupHandler,
            visible: this.popupConfig.formMode !== "review",
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          // visible: this.popupConfig.formMode !== "review",
          options: {
            icon: "close",
            onClick: this.onCancelPopupHandler,
            // visible: this.popupConfig.formMode !== "review",
          },
        },
      ];
    },

    getFormInstance() {
      if (
        this.$refs["gc-form-comp-shifts"] &&
        this.$refs["gc-form-comp-shifts"].$refs["gc-form-comp"]
      ) {
        return this.$refs["gc-form-comp-shifts"].$refs["gc-form-comp"];
      } else {
        return null;
      }
    },

    getDowntimeColumns() {
      return [
        {
          caption: "Description",
          dataField: "Description",
          dataType: "string",
          width: "100%",
          cssClass: "edit-cell-textbox-field description-column",
          setCellValue: async (newData, value, currentRowData) => {
            if (!currentRowData.Description) {
              this.addNewEditableRow();
            }
            newData.Description = value;

            return newData;
          },
          editorOptions: {
            maxLength: 100,
            onKeyDown: (e, lineData) => {
              if (!e.event) return;
              if (backwardTabbing(e) && lineData.rowIndex === 0) {
                e.event.preventDefault();
                this.$nextTick(() => {
                  this.setFocusOnField("EndTime");
                });
              }
            },
          },
        },
        {
          caption: "Start Time",
          dataField: "StartTime",
          dataType: "datetime",
          format: "HH:mm",
          minWidth: ColumnWidth.Time.minWidth,
          width: ColumnWidth.Time.width,
          cssClass: "edit-cell-datebox-field",
          editorOptions: {
            type: "time",
            placeholder: "Select Time",
            // min: this.model.StartTime,
            onInput: (e, context) => {
              this.normalizeTimeInput(e, context, {
                dataSource: this.getActiveTimeDataSource(),
                flagField: "StartTimeEnter",
              });
            },
          },
          setCellValue: (newData, value) => {
            newData.StartTime = value;
            newData.EndTime = null;
            newData.DurationMins = 0;
            newData.EndTimeEnter = false; // reset end time input flag when start time changes
            return newData;
          },
        },
        {
          caption: "End Time",
          dataField: "EndTime",
          dataType: "datetime",
          format: "HH:mm",
          cssClass: "edit-cell-datebox-field",
          editorOptions: {
            type: "time",
            placeholder: "Select Time",
            // max: this.model.EndTime,
            onInput: (e, context) => {
              this.normalizeTimeInput(e, context, {
                dataSource: this.getActiveTimeDataSource(),
                flagField: "EndTimeEnter",
              });
            },
          },
          minWidth: ColumnWidth.Time.minWidth,
          width: ColumnWidth.Time.width,
          setCellValue: (newData, value, currentRowData) => {
            newData.EndTime = value;

            if (currentRowData.StartTime && value) {
              const start = currentRowData.StartTime;
              const end = value;

              let duration = (end - start) / (1000 * 60); // duration in minutes
              if (duration < 0) {
                duration += 24 * 60; // adjust for overnight shifts
              }
              newData.DurationMins = Math.ceil(duration);
            } else {
              newData.DurationMins = 0;
            }
            return newData;
          },
        },
        {
          caption: "Duration (Hrs)",
          dataField: "DurationMins",
          dataType: "number",
          width: 100,
          minWidth: 100,
          allowEditing: false,
          calculateDisplayValue: (data) => {
            if (data.DurationMins > 0) {
              return minutesTo24Hour(data.DurationMins);
            }
            return data.DurationMins || 0;
          },
        },
        {
          dataField: "",
          caption: "",
          type: "buttons",
          buttons: [
            {
              hint: "Delete",
              icon: "trash",

              visible: this.popupConfig.formMode !== "review",
              onClick: async (e) => {
                const confirmDelete = await this.$confirm(
                  "Are you sure you want to delete this entry?",
                  "Delete Entry",
                );
                if (confirmDelete) {
                  this.dataGrid.deleteRow(e.row.rowIndex);
                }
              },
            },
          ],
          visible: this.popupConfig.formMode !== "review",
          width: 50,
          minWidth: 50,
        },
      ];
    },

    getProcessColumns() {
      return [
        {
          caption: "Code",
          dataField: "ProcessCode",
          minWidth: ColumnWidth.Code.minWidth,
          width: ColumnWidth.Code.width,
          cssClass: "edit-cell-textbox-field description-column",
          editorType: "dxSelectBox",
          editorOptions: {
            dataSource: ProcessCapacityService.dataSourceConfig(
              "api/ProcessList",
              {
                filter: [["Inactive", "=", "N"]],
                sort: "Code asc",
                select: "Code,Description, Inactive, RecordId",
              },
            ),
            displayExpr: "Code",
            valueExpr: "Code",
            searchEnabled: true,
            searchExpr: ["Code", "Description"],
            itemTemplate: (data) => {
              return ` <div class="custom-auto-complete" id="${data.Code}" >
                  <span class="auto-complete-primary">
                    ${data.Description}
                  </span>
                  <span class="record-secondary gc-grid-code">
                    ${data.Code}
                  </span>
                </div>`;
            },
            dropDownOptions: {
              minWidth: 200,
            },
            onFocusIn: (e) => {
              if (!e.event) return;
              e.event.target.select();
            },
            onValueChanged: (e, lineData) => {
              if (!e.event) return;
              var items = e.component.getDataSource().items();
              var item = items.filter((x) => x.Code == e.value);

              if (item) {
                this.ShiftProcessDataSource.update(lineData.data.id, {
                  ProcessDescription: item[0].Description,
                  ProcessRecordId: item[0].RecordId,
                });
              }

              this.dataGrid.cellValue(
                lineData.rowIndex,
                "ProcessCode",
                item[0].Code,
              );

              this.$nextTick(() => {
                this.dataGrid.closeEditCell();
                setTimeout(() => {
                  this.dataGrid.focus(
                    this.dataGrid.getCellElement(lineData.rowIndex, "Days"),
                  );
                  this.dataGrid.editCell(lineData.rowIndex, "Days");
                }, 100);
              });
            },
          },
          setCellValue: async (newData, value, currentRowData) => {
            if (!currentRowData.ProcessCode) {
              this.addNewEditableRow();
            }
            newData.ProcessCode = value;

            return newData;
          },
        },
        {
          caption: "Description",
          dataField: "ProcessDescription",
          width: "100%",
          minWidth: 200,
          allowEditing: false,
        },
        {
          caption: "Days",
          dataField: "Days",
          cssClass: "edit-cell-textbox-field",
          editorType: "dxTagBox",
          editorOptions: {
            items: [
              {
                text: "Monday",
                value: "Mon",
              },
              {
                text: "Tuesday",
                value: "Tue",
              },
              {
                text: "Wednesday",
                value: "Wed",
              },
              {
                text: "Thursday",
                value: "Thu",
              },
              {
                text: "Friday",
                value: "Fri",
              },
              {
                text: "Saturday",
                value: "Sat",
              },
              {
                text: "Sunday",
                value: "Sun",
              },
            ],
            displayExpr: "text",
            valueExpr: "value",
            searchEnabled: true,
            maxDisplayedTags: 2,
            onFocusIn: (e) => {
              if (!e.event) return;
              e.event.target.select();
            },
          },
          minWidth: ColumnWidth.WeekDay.minWidth + 20,
          width: ColumnWidth.WeekDay.width + 20,
          setCellValue: (newData, value) => {
            newData.Days = value;
            return newData;
          },
        },
        {
          caption: "Start Date",
          dataField: "DateStart",
          minWidth: ColumnWidth.Date.minWidth,
          width: ColumnWidth.Date.width,
          dataType: "date",
          editorType: "dxDateBox",
          format: "dd MMM yyyy",
          cssClass: "edit-cell-datebox-field",
          editorOptions: {
            type: "date",
            displayFormat: "dd MMM yyyy",
          },
          setCellValue: (newData, value) => {
            newData.DateStart = value;
            newData.DateEnd = null;
            return newData;
          },
        },
        {
          caption: "End Date",
          dataField: "DateEnd",
          minWidth: ColumnWidth.Date.minWidth,
          width: ColumnWidth.Date.width,
          dataType: "date",
          editorType: "dxDateBox",
          format: "dd MMM yyyy",
          cssClass: "edit-cell-datebox-field",
          editorOptions: {
            type: "date",
            displayFormat: "dd MMM yyyy",
            onFocusIn: (e, context) => {
              e.event.target.select();
              const rowData = context.data;
              e.component.beginUpdate();
              e.component.option("min", rowData.DateStart);
              e.component.endUpdate();
            },
            onFocusOut: async (e, context) => {
              const rowData = context.data;
              if (rowData.DateStart && rowData.DateEnd) {
                const start = new Date(rowData.DateStart);
                const end = new Date(rowData.DateEnd);
                if (end < start) {
                  e.component.option("value", null);
                  await this.$alert(
                    "End Date cannot be before Start Date.",
                    "Validation Error",
                  );

                  this.$nextTick(() => {
                    this.focusOnEditableGridCell("DateEnd", rowData);
                  });
                }
              }
            },
          },
          setCellValue: (newData, value) => {
            newData.DateEnd = value;
            return newData;
          },
        },
        {
          caption: "Override Shift",
          dataField: "HasUniqueShiftWindow",
          editorType: "dxSwitch",
          dataType: "boolean",
          width: 120,
          setCellValue: (newData, value) => {
            newData.HasUniqueShiftWindow = value;
            if (value === false) {
              newData.StartTime = null;
              newData.EndTime = null;
            }
            return newData;
          },
        },
        {
          caption: "Start Time",
          dataField: "StartTime",
          minWidth: ColumnWidth.Time.minWidth,
          width: ColumnWidth.Time.width,
          dataType: "datetime",
          format: "HH:mm",
          cssClass: "edit-cell-datebox-field",
          editorOptions: {
            type: "time",
            placeholder: "Select Time",
            onInput: (e, context) => {
              this.normalizeTimeInput(e, context, {
                dataSource: this.getActiveTimeDataSource(),
                flagField: "StartTimeEnter",
              });
            },
          },
          setCellValue: (newData, value) => {
            newData.StartTime = value;
            newData.EndTime = null;
            return newData;
          },
          cellTemplate: (data, info) => {
            if (info.data.HasUniqueShiftWindow === false) {
              return (data.innerHTML = `<div class='time-cell-template disabled-cell'> - </div>`);
            } else
              return (data.innerHTML = `<div class='time-cell-template'>${info.text}</div>`);
          },
        },
        {
          caption: "End Time",
          dataField: "EndTime",
          minWidth: ColumnWidth.Time.minWidth,
          width: ColumnWidth.Time.width,
          dataType: "datetime",
          format: "HH:mm",
          cssClass: "edit-cell-datebox-field",
          editorOptions: {
            type: "time",
            placeholder: "Select Time",
            onInput: (e, context) => {
              this.normalizeTimeInput(e, context, {
                dataSource: this.getActiveTimeDataSource(),
                flagField: "EndTimeEnter",
              });
            },
          },
          setCellValue: (newData, value) => {
            newData.EndTime = value;
            return newData;
          },
          cellTemplate: (data, info) => {
            if (info.data.HasUniqueShiftWindow === false) {
              return (data.innerHTML = `<div class='time-cell-template disabled-cell'> - </div>`);
            } else
              return (data.innerHTML = `<div class='time-cell-template'>${info.text}</div>`);
          },
        },
        {
          caption: "Override Downtime",
          dataField: "HasUniqueDownTime",
          editorType: "dxSwitch",
          dataType: "boolean",
          width: 140,
          showEditorAlways: true,
          editCellTemplate: "overrideDowntimeSwitchTemplate",
        },
        {
          caption: "Planning Deduction",
          dataField: "PlanningDeductionMinutes",
          editorType: "dxSwitch",
          dataType: "boolean",
          width: 140,
          editCellTemplate: "planningDeductionMinutesSwitchTemplate",
        },
        {
          dataField: "",
          caption: "",
          type: "buttons",
          buttons: [
            {
              hint: "Delete",
              icon: "trash",

              visible: this.popupConfig.formMode !== "review",
              onClick: async (e) => {
                const confirmDelete = await this.$confirm(
                  "Are you sure you want to delete this entry?",
                  "Delete Entry",
                );
                if (confirmDelete) {
                  this.dataGrid.deleteRow(e.row.rowIndex);
                }
              },
            },
          ],
          visible: this.popupConfig.formMode !== "review",
          width: 40,
          minWidth: 40,
        },
      ];
    },

    getColumns() {
      if (this.SelectedIndex === 0) {
        return this.getDowntimeColumns;
      } else {
        return this.getProcessColumns;
      }
    },

    getDataSource() {
      if (this.SelectedIndex === 0) return this.DownTimeDataSource._array;
      else return this.ShiftProcessDataSource._array;
    },

    dataGrid() {
      if (this.$refs["shifts-tab-grid-downtime"]) {
        return this.$refs["shifts-tab-grid-downtime"].instance;
      } else {
        return null;
      }
    },
  },
  watch: {
    getHotKeySave: {
      handler(val) {
        if (val && this.DowntimeDeductionPopupConfig.isPopupShow === false) {
          this.$store.dispatch("hotKey/setHotKeySave", false);
          this.onSavePopupHandler();
        }
      },
      deep: true,
    },
    model: {
      handler(newVal) {
        if (newVal) {
          if (
            newVal.ShiftDurationMins !== undefined &&
            newVal.ShiftDurationMins !== null &&
            newVal.ShiftDurationMins > 0
          ) {
            this.model.ShiftDurationHrs = minutesTo24Hour(
              newVal.ShiftDurationMins,
            );
          } else {
            this.model.ShiftDurationHrs = 0;
          }
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
.gc-popup-shifts {
  .dx-toolbar.dx-popup-title {
    height: 60px;
  }

  .toolbar-title-secondary {
    padding-left: unset !important;
    font-weight: 400;
    font-size: 14px;
  }

  .gc-text-area-large {
    label.dx-field-item-label {
      padding-top: 4px;
    }
    textarea.dx-texteditor-input {
      padding-top: unset !important;
    }
  }

  .gc-popup-form {
    .gc-tag-box {
      .dx-tagbox:not(.dx-texteditor-empty):not(.dx-editor-filled):not(
          .dx-editor-outlined
        )::after {
        border-bottom: 1px solid rgba(0, 0, 0, 0.42) !important;
      }
    }
  }

  .gc-popup-data-grid {
    padding-top: unset !important;
    .dx-datagrid-header-panel {
      height: 0px !important;
    }
    .shift-tabs {
      background-color: white;
    }

    .dx-datagrid .dx-datagrid-content {
      .dx-datagrid-table .dx-row .dx-editor-cell:not(.description-column) {
        padding-right: 5px !important;
        padding-left: 5px !important;
      }

      .dx-datebox {
        .dx-placeholder::before {
          padding-left: unset !important;
          padding-bottom: unset !important;
          padding-top: unset !important;
        }
      }

      // .dx-datebox.dx-texteditor:not(.dx-state-readonly)::after {
      //   content: "";
      //   border-bottom: 1px solid rgba(0, 0, 0, 0.42) !important;
      // }
    }

    tr.dx-data-row {
      > td.edit-cell-textbox-field.description-column {
        padding-left: 18px !important;
      }
    }

    .time-cell-template.disabled-cell {
      text-align: center;
    }

    .overrid-downtime-switch {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .dx-switch {
        padding-left: 5px;
      }

      .dx-icon.dx-icon-edit {
        margin-right: 10px !important;
      }

      .dx-button-text {
        font-size: 8px;
        // padding-left: 10px;
      }
    }
  }
}
</style>
